import styles from './style.postcss';

import React, { Component } from 'react';
import { Link } from 'react-router';
import TableWithExpandablePanel from 'components/TableWithExpandablePanel';
import { parseProductionStatus } from 'domain/ProductionStatus';
import { ProductionStatus, mediaQuery, connect, Icon, testClass, Tooltip } from 'omni-common-ui';
import classnames from 'classnames';
import Body from './Body';
import OptionsCell from './OptionsCell';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import is from 'is_js';

const NOT_APPLICABLE = '-';

class CourseViewTable extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: mediaQuery('(min-width: 1024px)').matches };
    this._setUpData(props);
  }

  componentWillUpdate(props) {
    this._setUpData(props);
  }

  _onAddNoteClicked(student, e) {
    this.props.onAddNoteClicked(student);
    e.preventDefault();
    e.stopPropagation();
  }

  _setUpData(props) {
    const header = React.Children.toArray(props.children)
        .find((child) => child.type === TableWithExpandablePanel.Header);
    const lastHeaderRow = new List(React.Children.toArray(header.props.children)).last();
    this._isPanelHeaderSmall = new List(React.Children.toArray(lastHeaderRow.props.children))
        .every((cell) => cell.props.small);
  }

  _onExpandedChange(expanded) {
    this.setState({ expanded });
  }

  _getStudentAcademicLink(studentId) {
    return this.props.buildRoute(`/student/${studentId}`);
  }

  _renderUnassignedReader(student) {
    const { extraInfo } = this.props;
    const readingItemClassName = classnames(styles.studentNameWithStatusAndReading_reading_item,
      { [styles.__collapsed]: ! this.state.expanded });
    const descriptionClassName = classnames(readingItemClassName,
      styles.studentNameWithStatusAndReading_reading_description);
    const unassignedReader = extraInfo &&
      extraInfo.find((item) => item.studentId === student.studentGeneralInfo.id);

    const currentLevel = unassignedReader ? unassignedReader.currentLevel : NOT_APPLICABLE;
    const completedInCurrentLevel = unassignedReader ?
      unassignedReader.completedInCurrentLevel : NOT_APPLICABLE;
    const totalInCurrentLevel = unassignedReader ?
      unassignedReader.totalInCurrentLevel : NOT_APPLICABLE;
    const totalReader = unassignedReader ? unassignedReader.completedInTotal : NOT_APPLICABLE;
    const tooltip = unassignedReader ?
      'Unassigned reading tells you the student’s current level,' +
        ' the number of books they have read out of the total number in that level' +
        ' and the total number of books read from the unassigned reading library.' +
        `  This student is in level ${currentLevel}, having read ${completedInCurrentLevel} book` +
        ` out of the ${totalInCurrentLevel} books in level ${currentLevel},` +
        ` and ${totalReader} books total from the Reading Library.` :
      'Unassigned reading tells you the student’s current level,' +
        ' the number of books they have read out of the total number in that level' +
        ' and the total number of books read from the unassigned reading library.' +
        '  This student has not gone to the Reading Library yet so does not have' +
        ' a level and has not read any books yet.';

    return <Tooltip text={tooltip}
        placement="right"
        overlayClassName={styles.studentNameWithStatusAndReading_reading_tooltip}>
      <div className={styles.studentNameWithStatusAndReading_reading}>
        <div className={descriptionClassName}>UNASSIGNED</div>
        <div className={readingItemClassName}>
          {`Current level: ${currentLevel}`}
        </div>
        <div className={readingItemClassName}>
          {`Completed in current level: ${completedInCurrentLevel}/${totalInCurrentLevel}`}
        </div>
        <div className={readingItemClassName}>
          {`Total read: ${totalReader}`}
        </div>
      </div>
    </Tooltip>;
  }

  _renderStudentNameWithStatusAndReader(student) {
    const colSpan = this.state.expanded ? 2 : 1;
    const { isInProduction } = student;
    const status = Object.assign({ isInProduction }, parseProductionStatus(student.status));
    return <TableWithExpandablePanel.Cell colSpan={colSpan}>
      <div className={styles.studentNameWithStatusAndReading}>
        <div className={styles.studentNameWithStatusAndReading_nameAndStatus}>
          {this._renderStudentNameContent(student)}
          {
            this.state.expanded &&
            <ProductionStatus status={status.fullName}
                initial={undefined}
                highlighted={status.isInProduction} />
          }
          {
            ! this.state.expanded &&
            <div className={styles.studentNameWithStatusAndReading_status}>
              <ProductionStatus status={status.fullName}
                  initial={status.initial}
                  highlighted={status.isInProduction} />
            </div>
          }
        </div>
        {this._renderUnassignedReader(student)}
      </div>
    </TableWithExpandablePanel.Cell>;
  }

  _renderStudentNameWithStatus(student) {
    return <div className={styles.StudentCellWithStatus}>
      {this._renderStudentNameContent(student)}
      {this._renderProductionStatus(student)}
    </div>;
  }

  _renderStudentName(student) {
    if (this.props.showSkill) {
      let rowSpan = 0;
      const studentSkills = this.props.students
        .filter((s) => s.studentGeneralInfo.id === student.studentGeneralInfo.id)
        .map((s) => s.skill);

      if (studentSkills.indexOf(student.skill) === 0) {
        rowSpan = studentSkills.length;
      } else {
        return null;
      }

      return <TableWithExpandablePanel.Cell rowSpan={rowSpan}>
        {this._renderStudentNameContent(student)}
      </TableWithExpandablePanel.Cell>;
    }

    return this._renderStudentNameContent(student);
  }

  _renderStudentNameContent(student) {
    const classes = classnames(styles.StudentCell, testClass('student-cell'),
      { [styles.__collapsed]: ! this.state.expanded });
    return <div className={classes}>
      {/* Lots of nesting because INTERNET EXPLORER */}
      <div className={styles.StudentCell_inner}>
        <div className={styles.StudentCell_nameWrapper}>
          <Link to={this._getStudentAcademicLink(student.studentGeneralInfo.id)}>
            {`${student.studentGeneralInfo.firstName} ${student.studentGeneralInfo.lastName}`}
          </Link>
          <div>{student.studentGeneralInfo.localName}</div>
        </div>
        {
          this.props.onAddNoteClicked &&
          <div className={styles.StudentCell_icon}
              onClick={(e) => this._onAddNoteClicked(student, e)}>
            <Icon id="new-message" />
          </div>
        }
        {this.props.renderAddNoteDialog && this.props.renderAddNoteDialog(student)}
      </div>
    </div>;
  }

  _renderAch(student) {
    return <div>
      {
        student.ach.produced > 0 &&
        `${parseInt((student.ach.present * 100) / student.ach.produced, 10)}%`
      }
      <br />
      {`(${student.ach.present}/${student.ach.produced})`}
    </div>;
  }

  _renderProductionStatus(student) {
    const { isInProduction } = student;
    const status = Object.assign({ isInProduction }, parseProductionStatus(student.status));
    return <ProductionStatus status={status.fullName}
        initial={this.state.expanded ? undefined : status.initial}
        highlighted={status.isInProduction} />;
  }

  _renderSkills(student) {
    return <div>{student.skill}</div>;
  }

  _shouldRenderAch() {
    return this.props.showAch && this.state.expanded;
  }

  render() {
    const { students, children, highlightedColumns, stripeRows, extraInfo } = this.props;

    const bodyComponent = children.find((child) => child.type === Body);
    const {
      children: buildCell,
      cellOptions,
      firstOptionHeader,
      secondOptionHeader } = bodyComponent.props;
    const header = children.find((child) => child.type === TableWithExpandablePanel.Header);
    const showExtraInfo = is.not.undefined(extraInfo) && is.existy(extraInfo);

    return <TableWithExpandablePanel rows={students}
        highlightedColumns={highlightedColumns}
        stripeRows={stripeRows}
        isFullHeightToPanel={showExtraInfo}
        onExpandedChange={(expanded) => this._onExpandedChange(expanded)}
        onlyRowDivider={this.props.onlyRowDivider}>
      {header}
      <TableWithExpandablePanel.Body>
        {
          (...args) => <OptionsCell args={args}
              cellOptions={cellOptions}
              buildCell={buildCell}
              firstOptionHeader={firstOptionHeader}
              secondOptionHeader={secondOptionHeader} />
        }
      </TableWithExpandablePanel.Body>
      <TableWithExpandablePanel.Panel>
        <TableWithExpandablePanel.Header>
          <TableWithExpandablePanel.Row>
            <TableWithExpandablePanel.Cell columnId="student-name" small={this._isPanelHeaderSmall}>
              Student Name
            </TableWithExpandablePanel.Cell>
            {
              this._shouldRenderAch() &&
              <TableWithExpandablePanel.Cell columnId="ach" small={this._isPanelHeaderSmall}>
                % Present<br />(ACH)
              </TableWithExpandablePanel.Cell>
            }
            {
              this.state.expanded && ! this.props.showSkill &&
              <TableWithExpandablePanel.Cell columnId="production-status"
                  small={this._isPanelHeaderSmall}>
                Status
              </TableWithExpandablePanel.Cell>
            }
            {
              this.state.expanded && this.props.showSkill &&
              <TableWithExpandablePanel.Cell columnId="skill"
                  small={this._isPanelHeaderSmall}>
                Skill
              </TableWithExpandablePanel.Cell>
            }
          </TableWithExpandablePanel.Row>
        </TableWithExpandablePanel.Header>
        <TableWithExpandablePanel.Body>
          {
            (student, columnId) => {
              switch (columnId) {
                case 'student-name':
                  if (showExtraInfo) {
                    return this._renderStudentNameWithStatusAndReader(student);
                  }

                  return this.props.showSkill || this.state.expanded ?
                    this._renderStudentName(student) :
                    this._renderStudentNameWithStatus(student);
                case 'ach':
                  return this._renderAch(student);
                case 'production-status':
                  if (showExtraInfo) {
                    return null;
                  }

                  return this._renderProductionStatus(student);
                case 'skill':
                  return this._renderSkills(student);
                default:
                  throw new Error(`Invalid column ${columnId}`);
              }
            }
          }
        </TableWithExpandablePanel.Body>
      </TableWithExpandablePanel.Panel>
    </TableWithExpandablePanel>;
  }
}

CourseViewTable.propTypes = {
  students: PropTypes.arrayOf(PropTypes.any),
  children: PropTypes.node,
  stripeRows: PropTypes.arrayOf(PropTypes.number),
  highlightedColumns: PropTypes.arrayOf(PropTypes.number),
  showAch: PropTypes.bool,
  showSkill: PropTypes.bool,
  onlyRowDivider: PropTypes.bool,
  buildRoute: PropTypes.func,
  onSaveNote: PropTypes.func,
  onAddNoteClicked: PropTypes.func,
  renderAddNoteDialog: PropTypes.func,
  extraInfo: PropTypes.object, // Show in first two columns. (e.g. unassigned reader info)
};

export default connect()(CourseViewTable);



// WEBPACK FOOTER //
// ./components/CourseViewTable/component.jsx